export const getToolbarStyles = ({ isMobile }) => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  alignItems: isMobile ? 'stretch' : 'center',
  justifyContent: 'space-between',
  gap: isMobile ? '12px' : '16px',
  mb: '12px',
});
